export const navigate = (link) => {
  window.location.href = link;
  return true;
};